import React, { Component } from "react";
import ReactDOM from "react-dom";

const REJECT_REASONS = [
    "Los datos sugeridos son incorrectos.",
    "No deseo modificar los datos de mi empresa.",
    "Otro"
];

class RejectUpdateRequestModal extends Component {
    state = {
        selected: null,
        customReason: ""
    };

    handleSelect = idx => {
        this.setState({ selected: idx });
    };

    handleCustomChange = e => {
        this.setState({ customReason: e.target.value });
    };

    handleSubmit = () => {
        let reason = REJECT_REASONS[this.state.selected];
        if (reason === "Otro") reason = this.state.customReason;
        this.props.onConfirm(reason);
    };

    render() {
        const { show, onClose } = this.props;
        if (!show) return null;
        return ReactDOM.createPortal(
            <div className="modal fade show d-block" tabIndex="-1" style={{background: "rgba(0,0,0,0.3)"}}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-4">
                        <div className="modal-body px-15 py-5"> 
                            <h5 className="text-dark font-weight-bold my-1 mr-5">Rechazo de la solicitud de modificación de los datos de mi empresa</h5>
                            <div className="text-muted"> Selecciona el motivo de rechazo de la lista.</div>
                            <div className="card card-custom  gutter-b my-5"> 
                                <div className="card-body pt-5  "> 
                                    <div className="mb-5">
                                        <div className="col-md-12">
                                            <table className="table mb-4">
                                                <thead>
                                                    <tr>
                                                        <th>Seleccionar</th>
                                                        <th>Motivo de rechazo</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-muted    ">
                                                    {REJECT_REASONS.map((reason, idx) => (
                                                        <tr key={reason}>
                                                            <td>
                                                                <input
                                                type="radio"
                                                name="reject_reason"
                                                checked={this.state.selected === idx}
                                                onChange={() => this.handleSelect(idx)}
                                            />
                                        </td>
                                        <td>
                                            {reason === "Otro" ? (
                                                <div>
                                                    Otro<br/>
                                                    <div className="d-flex align-items-center">
                                                        <span style={{width: '200px'}}>Describe el motivo:</span>
                                                        <input
                                                            type="text"
                                                            className="form-control mt-2"
                                                            value={this.state.customReason}
                                                            disabled={this.state.selected !== idx}
                                                            onChange={this.handleCustomChange}
                                                            placeholder="Aquí describo el motivo de mi rechazo."
                                                        />
                                                    </div>  
                                                </div>
                                            ) : reason}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                                            </table>
                                        </div>
                                    </div>  
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end gap-2">
                            <button className="btn btn-secondary mr-2" onClick={onClose}>Cancelar</button>
                            <button
                                className="btn btn-danger"
                                disabled={this.state.selected === null || (this.state.selected === 2 && !this.state.customReason)}
                                onClick={this.handleSubmit}
                            >
                                Rechazar
                            </button>
                        </div>
                    </div>
                </div>
            </div>,
            document.body
        );
    }
}

export default RejectUpdateRequestModal;
